export const numberRegex = /^[0-9]+$/;
export const decimalNumberWithCommaRegex = /^\d+([,\d]?)([\d]+)?$/;
export const phoneNumberRegex = /^8[0-9]{8,14}$/;
export const emailRegex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;